import React, { MouseEvent } from 'react';
import { Surgerie } from 'types/surgerie';
import SurgerieItemModule from './SurgerieItemModule';
import List from 'components/list/List';
import SurgerieMenu from '../menu/SurgerieMenu';
import { useSurgerie } from '../../hooks/useSurgerie';

type SurgerieListModuleProps = {
  surgeries: Surgerie[];
};

const SurgerieListModule: React.FC<SurgerieListModuleProps> = ({ surgeries }) => {
  const { anchorEl, setAnchorEl, setSelectedSurgerie } = useSurgerie();

  function handleActionClick(event: MouseEvent<HTMLButtonElement>, surgerie: Surgerie) {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    setSelectedSurgerie(surgerie);
  }

  return (
    <>
      {anchorEl && <SurgerieMenu anchorEl={anchorEl} />}
      <List>
        {surgeries.map(surgerie => (
          <SurgerieItemModule key={surgerie.id_int} surgerie={surgerie} onActionClick={handleActionClick} />
        ))}
      </List>
    </>
  );
};

export default SurgerieListModule;
